
import injectNewHeaderCartData from '../../methods/injectNewHeaderCartData'

export default {
    namespaced: true,
    state: {

        //Prepare data values
        labels: null,
        productInfo: "",
        productInfoTabs: "",
        productConfiguratorSettings: "",
        relatedCourseBanner: "",
        relatedCollectionBanner: "",
        promotedCards: "",

        //Configurator values
        amount: 0,
        levelOneID: null,
        levelTwoID: null,

        //show mini-cart notification
        addToCartHtmlString: {},
        showCartNotification: false,
        cartIconAmount: null,
        cartPopupProductList: null
    },
    mutations:{
        //Set data for components
        setLabels(state, newLabels) {
            state.labels = newLabels
        },
        setProductInfo(state, newProductInfo) {
            state.productInfo = newProductInfo
        },
        setProductInfoTabs(state, newProductInfoTabs) {
            state.productInfoTabs = newProductInfoTabs
        },
        setProductConfiguratorSettings(state, newProductConfiguratorSettings) {
            state.productConfiguratorSettings = newProductConfiguratorSettings
        },
        setRelatedCourseBanner(state, newRelatedCourseBanner) {
            state.relatedCourseBanner = newRelatedCourseBanner
        },
        setRelatedCollectionBanner(state, newRelatedCollectionBanner) {
            state.relatedCollectionBanner = newRelatedCollectionBanner
        },
        setPromotedCards(state, newPromotedCards) {
            state.promotedCards = newPromotedCards
        },

        //Configurator mutations
        setLevelOneID(state, newValue) {
            state.levelOneID = newValue
        },
        setLevelTwoID(state, newValue) {
            state.levelTwoID = newValue
        },
        setAmount(state, newValue) {
            state.amount = newValue
        }, 

        //show mini-cart notificaiton
        setCartNotificationHtml(state, markup) {
            state.addToCartHtmlString = markup
        },
        setCartIconAmount(state, newAmount) {
            state.cartIconAmount = newAmount
        },
        displayCartNotification(state, newState) {
            state.showCartNotification = newState
        },
        setCartPopupProductList(state, newProductList) {
            state.cartPopupProductList = newProductList
        }
    },
    actions:{

        //Configurator actions 
        addToCart(context, payload) {
            const langElement = document.querySelector('HTML').getAttribute('commerce-lang')
            let url = process.env.ADD_TO_CART_URL
                .replace("{code}", payload.code)
                .replace("{quantity}", payload.quantity)
                .replace("{language}", langElement)

            fetch(url)
                .then(res => {
                    if (res.ok) {
                        return res.json()
                    } else {
                        throw "Error - adding to cart"
                    }
                })
                .then(json => {
                    //Track in matomo
                    var _paq = window._paq = window._paq || [];
                    _paq.push(['addEcommerceItem', json.AddedItemSKU, json.AddedItemName, false, json.AddedItemPrice, json.AddedItemQuantity]);
                    _paq.push(['trackEcommerceCartUpdate', json.CartTotalValue]);
                    
                    context.dispatch("showAddToCartNotification", json.ItemAddedHtml)
                    context.commit("setCartIconAmount", json.ItemsInCart)
                    context.commit("setCartPopupProductList", json.Html)
                    injectNewHeaderCartData()
                })
                .catch(err => {
                    console.error(err)
                }) 
        },
        showAddToCartNotification(context, markup) {
            context.commit("setCartNotificationHtml", markup)
            context.commit("displayCartNotification", true)
        },
    }
}
